<template lang="html">
  <router-link v-bind="$attrs" :to="to" @click.native="clickHandler" tag="a" :class="routeClass">
    <slot></slot>
  </router-link>
</template>

<script>
  export default {
    name: 'reloadable-router-link',
    props: {
      to: {
        type: [Object, String],
        default: '/',
      },
      routeClass: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        currentRoute: null,
      };
    },

    created() {
      this.currentRoute = this.$route.params.conceptMenuId;
    },

    methods: {
      clickHandler($event) {
        if (!($event.ctrlKey || $event.metaKey) && this.currentRoute === this.to.params.conceptMenuId) {
          const query = { ...this.$route.query, _: new Date().getTime() };
          const newRoute = { ...this.$route, query };
          this.$router.replace(newRoute);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/reloadable-router-link.vue